import React from 'react';

function IdleTimeoutWarning({ remainingTime, onExtend, onLogout }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-xl p-6 max-w-sm mx-4">
        <div className="text-center">
          <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>

          <h3 className="text-lg font-bold text-gray-800 mb-2">
            세션 만료 예정
          </h3>

          <p className="text-gray-600 mb-4">
            장시간 활동이 없어 <span className="font-bold text-red-500">{remainingTime}초</span> 후<br />
            자동으로 로그아웃됩니다.
          </p>

          <div className="flex space-x-3">
            <button
              onClick={onLogout}
              className="flex-1 py-2 px-4 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition font-medium"
            >
              로그아웃
            </button>
            <button
              onClick={onExtend}
              className="flex-1 py-2 px-4 bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition font-medium"
            >
              연장하기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IdleTimeoutWarning;
